import { ModelTemplate } from "@models/base/helper-types";
import { MainMenuItem, MainMenuItemType, MainMenuItemVisibility } from "./main-menu-item";
import { PREDEFINED_MAIN_MENU_ITEMS } from "./predefined-menu-items";

export const DEFAULT_MAIN_MENU: ModelTemplate<MainMenuItem, '_vis'>[] = [
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.dashboard
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.mentions
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.events
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.projects
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.wiki
    },
    {
        visibility: MainMenuItemVisibility.Mobile,
        ...PREDEFINED_MAIN_MENU_ITEMS.newtask
    },
    {
        id: 'separator1',
        type: MainMenuItemType.Separator
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.tasksFolder,
        children: [
            {
                ...PREDEFINED_MAIN_MENU_ITEMS.favorites,
            },
            {
                ...PREDEFINED_MAIN_MENU_ITEMS.inbox,
            },
            {
                ...PREDEFINED_MAIN_MENU_ITEMS.outgoing,
            },
            {
                ...PREDEFINED_MAIN_MENU_ITEMS.inprogress,
            },
            {
                id: 'separator2',
                type: MainMenuItemType.Separator
            },
            {
                visibility: MainMenuItemVisibility.Mobile,
                ...PREDEFINED_MAIN_MENU_ITEMS.kanbans,
            },
            {
                visibility: MainMenuItemVisibility.Desktop,
                ...PREDEFINED_MAIN_MENU_ITEMS.kanbansFolder,
            },
            {
                id: 'separator3',
                type: MainMenuItemType.Separator
            },
            {
                ...PREDEFINED_MAIN_MENU_ITEMS.sprint,
            },
            {
                ...PREDEFINED_MAIN_MENU_ITEMS.backlog,
            },
            {
                ...PREDEFINED_MAIN_MENU_ITEMS.closed,
            },
        ]
    },
    {
        id: 'separator4',
        type: MainMenuItemType.Separator
    },
    {
        visibility: MainMenuItemVisibility.Mobile,
        ...PREDEFINED_MAIN_MENU_ITEMS.chats,
    },
    {
        visibility: MainMenuItemVisibility.Desktop,
        ...PREDEFINED_MAIN_MENU_ITEMS.groupChatsFolder,
    },
    {
        visibility: MainMenuItemVisibility.Desktop,
        ...PREDEFINED_MAIN_MENU_ITEMS.directChatsFolder,
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.spacer
    },
    {
        id: 'separator5',
        type: MainMenuItemType.Separator
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.settings,
    },
    {
        id: 'separator6',
        type: MainMenuItemType.Separator
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.support,
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.docs,
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.tariffs,
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.uploads,
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.tgnews,
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.download,
    },

];

export const DEFAULT_MAIN_MENU_NOORG: ModelTemplate<MainMenuItem, '_vis'>[] = [
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.profile,
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.events
    },
    {
        id: 'separator1',
        type: MainMenuItemType.Separator
    },
    {
        id: 'neworg',
        unique: true,
        type: MainMenuItemType.Link,
        title: 'Создать организацию',
        icon: 'vzi-org',
        route: ['settings', 'profile', 'org', 'new'],
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.spacer
    },
    {
        id: 'separator2',
        type: MainMenuItemType.Separator
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.settings,
    },
    {
        id: 'separator3',
        type: MainMenuItemType.Separator
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.support,
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.docs,
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.tgnews,
    },
    {
        ...PREDEFINED_MAIN_MENU_ITEMS.download,
    },

];
